import { useState } from "react";
import { FilteredTagsStateContext } from "src/context/FilteredTagsStateContext";
import { TypeTagBase } from "src/types/contentfulTypes";

interface TagStateProviderType {
  children: React.ReactNode;
}
const TagStateProvider = ({ children }: TagStateProviderType) => {
  const [filteredTags, setFilteredTags] = useState<TypeTagBase[] | []>([]);

  return (
    <FilteredTagsStateContext.Provider
      value={{ filteredTags, setFilteredTags }}
    >
      {children}
    </FilteredTagsStateContext.Provider>
  );
};

export { TagStateProvider };
